import { render, staticRenderFns } from "./VoyageSummary.vue?vue&type=template&id=63f7cdce&scoped=true"
import script from "./VoyageSummary.vue?vue&type=script&lang=js"
export * from "./VoyageSummary.vue?vue&type=script&lang=js"
import style0 from "./VoyageSummary.vue?vue&type=style&index=0&id=63f7cdce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f7cdce",
  null
  
)

export default component.exports